var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "coupon-reward-container" }, [
    _c(
      "div",
      [
        _vm.couponReward.prizeType === 1
          ? _c("el-tag", { attrs: { size: "small" } }, [_vm._v("代金券")])
          : _vm.couponReward.prizeType === 2
          ? _c("el-tag", { attrs: { size: "small" } }, [_vm._v("积分")])
          : _vm._e(),
        _vm._v(" "),
        _c("el-divider", { attrs: { direction: "vertical" } }),
      ],
      1
    ),
    _vm._v(" "),
    _vm.couponReward.prizeType === 1
      ? _c("div", { staticStyle: { width: "300px" } }, [
          _c("span", [_vm._v(_vm._s(_vm.couponReward.couponName))]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.couponReward.prizeType === 1
      ? _c(
          "div",
          [
            _c("el-divider", { attrs: { direction: "vertical" } }),
            _vm._v(" "),
            _c("span", [
              _vm._v("已领取数量：" + _vm._s(_vm.couponReward.usedStock)),
            ]),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.couponReward.prizeType === 1
      ? _c(
          "div",
          [
            _c("el-divider", { attrs: { direction: "vertical" } }),
            _vm._v("\n    券库存："),
            _c("el-input-number", {
              staticStyle: { width: "200px" },
              attrs: {
                size: "small",
                placeholder: "请输入券库存",
                min: _vm.minStock,
                max: 999999,
              },
              model: {
                value: _vm.couponReward.stock,
                callback: function ($$v) {
                  _vm.$set(_vm.couponReward, "stock", $$v)
                },
                expression: "couponReward.stock",
              },
            }),
            _vm._v(" "),
            _c("el-divider", { attrs: { direction: "vertical" } }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.couponReward.prizeType === 1
      ? _c(
          "div",
          [
            _vm._v("\n    单次发放数量："),
            _c("el-input-number", {
              attrs: {
                size: "small",
                placeholder: "请输入单次发放数量",
                min: _vm.minCouponCount,
                max: 999999,
              },
              model: {
                value: _vm.couponReward.couponCount,
                callback: function ($$v) {
                  _vm.$set(_vm.couponReward, "couponCount", $$v)
                },
                expression: "couponReward.couponCount",
              },
            }),
            _vm._v(" "),
            _c("el-divider", { attrs: { direction: "vertical" } }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.couponReward.prizeType === 2
      ? _c(
          "div",
          [
            _vm._v("\n    积分："),
            _c("el-input-number", {
              attrs: {
                size: "small",
                placeholder: "请输入积分",
                min: _vm.minIntegral,
                max: 999999,
              },
              model: {
                value: _vm.couponReward.integral,
                callback: function ($$v) {
                  _vm.$set(_vm.couponReward, "integral", $$v)
                },
                expression: "couponReward.integral",
              },
            }),
            _vm._v(" "),
            _c("el-divider", { attrs: { direction: "vertical" } }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      [
        _vm._v("\n    中奖率："),
        _c("el-input-number", {
          attrs: {
            size: "small",
            placeholder: "请输入中奖率",
            min: 0,
            step: 0.1,
            precision: 1,
            max: 100,
          },
          model: {
            value: _vm.couponReward.winRate,
            callback: function ($$v) {
              _vm.$set(_vm.couponReward, "winRate", $$v)
            },
            expression: "couponReward.winRate",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }